import { memo } from 'react';
import { HStack, Text } from '@chakra-ui/react';

import IconButton from 'shared/IconButton';
import Tag from 'shared/Tag';

const CustomProjectCasesCardsTags = ({
  companyLogo,
  companyLogoProps,
  domain,
  isCompactDesign = false,
  ...props
}) => (
  <HStack h={isCompactDesign ? '48px' : { mobile: '54px', laptop: '64px' }} gap="12px" {...props}>
    <IconButton
      icon={companyLogo}
      disableHover
      boxSize={{ mobile: '54px', laptop: '64px' }}
      bg="bg.white"
      border="none"
      {...companyLogoProps}
    />

    <Tag
      as="div"
      h="full"
      p={isCompactDesign ? '16px 18px' : { mobile: '16px 18px', laptop: '19px 32px' }}
      border="none"
      bg="bg.white"
      zIndex="2"
    >
      <Text
        textStyle="h1"
        fontSize={isCompactDesign ? '16px' : { mobile: '16px', laptop: '20px' }}
        fontWeight={isCompactDesign ? '400px' : '500'}
        color="text.steelGray"
      >
        {domain}
      </Text>
    </Tag>
  </HStack>
);

export default memo(CustomProjectCasesCardsTags);
